const searchHomeRouter = [
  {
    path: 'search-result/:id',
    name: 'HomeSearch',
    component: () => import('@/views/SearchHome/SearchHome'),
    meta: { requiresAuth: false }
  }
];
export default searchHomeRouter;
